import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["grid", "currentPage"];
  static values = {
    itemsPerPage: { type: Number, default: 16 },
    totalAvatars: { type: Number, default: 116 },
  };

  connect() {
    this.currentPage = 1;
    this.totalPages = Math.ceil(
      this.totalAvatarsValue / this.itemsPerPageValue
    );
    this.updateGrid();
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updateGrid();
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updateGrid();
    }
  }

  updateGrid() {
    const start = (this.currentPage - 1) * this.itemsPerPageValue + 1;
    const end = Math.min(
      start + this.itemsPerPageValue - 1,
      this.totalAvatarsValue
    );

    this.gridTarget.innerHTML = "";

    for (let i = start; i <= end; i++) {
      const template = this.createAvatarTemplate(i);
      this.gridTarget.insertAdjacentHTML("beforeend", template);
    }

    this.currentPageTarget.textContent = this.currentPage;
  }

  createAvatarTemplate(number) {
    return `
      <label class="relative block cursor-pointer group">
        <input type="radio" name="avatar_number" value="${number}" class="hidden peer">
        <div class="aspect-square rounded-xl overflow-hidden border-2 border-transparent 
                    peer-checked:border-indigo-500 peer-checked:scale-110
                    transition-all duration-200
                    hover:scale-105 hover:shadow-lg
                    bg-gradient-to-br from-indigo-50 to-purple-50 dark:from-slate-800 dark:to-purple-900">
          <img src="https://kozenetpro-avatars.s3.us-east-1.amazonaws.com/avatars/Number=${number}.svg" 
               class="w-full h-full p-3" 
               loading="lazy">
          <div class="absolute inset-0 bg-indigo-500/10 opacity-0 peer-checked:opacity-100 transition-opacity"></div>
          <div class="absolute top-2 right-2 bg-indigo-600 rounded-full p-1 opacity-0 peer-checked:opacity-100 transition-opacity">
            <svg class="w-4 h-4 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
            </svg>
          </div>
        </div>
      </label>
    `;
  }
}
